module.exports = __webpack_public_path__ + "img/dwonlaod-anroid-min.979fe05b.png";